// page-terms ページのjs
import htmx from "htmx.org";
import "../sass/page-terms.scss";

document.addEventListener("DOMContentLoaded", () => {});

// ▼▼▼▼▼ DOMが安定した後に実行
const HTMX_ELM_COUNT = htmx.findAll(`[hx-trigger="load"]`).length;
let LOADED_COUNT = 0;
htmx.on("htmx:afterSettle", () => {
  LOADED_COUNT += 1;

  if (HTMX_ELM_COUNT === LOADED_COUNT) {
    // ここにDOMが安定した後に実行したい処理を記述する
  }
});
// ▲▲▲▲▲
